import { createApiClient } from '../shared/http/ApiClient.js';
import type { RouteLoader } from '../shared/ssr/RouteLoader.js';
import { headDeBusqueda } from './buscar.head.js';
import { BusquedaRepository } from './models/repositories/BusquedaRepository.js';
import type { BusquedaData } from './models/entities/BusquedaData.js';
import { CACHE_TAG, PUBLIC_SEARCH_Q_MAX } from '@ahora-patagonia/contracts';

export const BUSCAR_ROUTE_KEY = 'buscar';

/**
 * Loader de la búsqueda. Los resultados son `noindex,follow`: cada búsqueda es una URL
 * distinta y el crawler no tiene nada que indexar ahí — las notas ya tienen su dirección.
 *
 * Sin `?q=` resuelve **todas las noticias**: la pantalla es una búsqueda incremental y entra
 * mostrando la lista completa, así que el primer render tiene que traerla del server (si no,
 * el lector ve un vacío hasta que hidrate).
 */
export const buscarLoader: RouteLoader<BusquedaData> = async (ctx) => {
  const q = (ctx.query['q'] ?? '').trim().slice(0, PUBLIC_SEARCH_Q_MAX);

  const api = createApiClient({
    baseUrl: process.env['SSR_API_URL'] ?? 'http://localhost:3000',
    headers: { host: ctx.headers['host'] ?? '' },
  });
  const data = await new BusquedaRepository(api).buscar(q);

  return {
    data,
    head: headDeBusqueda(q, ctx.site),
    // Sin tags de contenido (60s de TTL alcanzan); `shell` sí, por el menú de la cabecera.
    cache: { sMaxAge: 60, tags: [CACHE_TAG.shell, CACHE_TAG.ads], visibility: 'public' },
  };
};
